module.exports = __webpack_public_path__ + "img/b02.7f12e0f5.png";